<template>
  <div class="pessoas-redefinir-senha-container">
    <v-btn icon absolute top left @click="$router.go(-1)" class="tertiary ml-1">
      <v-icon color="white">mdi-arrow-left</v-icon>
    </v-btn>
    <v-card class="pessoas-redefinir-senha-container1" elevation="8">
      <div class="pessoas-redefinir-senha-header mt-3">
        <span>
          <v-icon color="tertiary" size="30" class="mr-2">
            mdi-key-variant
          </v-icon>
        </span>
        <h1>Redefinir Senha</h1>
      </div>
      <v-form
        @submit.prevent="$lojas_usuarios.trocarSenha"
        class="pessoas-redefinir-senha-form"
      >
        <v-row class="mt-12 mb-4">
          <BaseTextField
            label="Senha atual"
            required
            id="senha"
            name="senha"
            placeholder="******"
            v-model="$lojas_usuarios.user.old_password"
            :type="$lojas_usuarios.user.show_old_pass ? 'text' : 'password'"
            :append-icon="
              $lojas_usuarios.user.show_old_pass
                ? $config.icons.viewOff
                : $config.icons.view
            "
            @click:append="
              $lojas_usuarios.user.show_old_pass =
                !$lojas_usuarios.user.show_old_pass
            "
            tabindex="1"
            autocomplete="off"
          ></BaseTextField>
        </v-row>
        <v-row class="mb-4">
          <BaseTextField
            label="Nova senha"
            required
            id="senha2"
            name="senha2"
            placeholder="******"
            v-model="$lojas_usuarios.user.senha"
            :type="$lojas_usuarios.user.show_senha ? 'text' : 'password'"
            :append-icon="
              $lojas_usuarios.user.show_senha
                ? $config.icons.viewOff
                : $config.icons.view
            "
            @click:append="
              $lojas_usuarios.user.show_senha = !$lojas_usuarios.user.show_senha
            "
            tabindex="2"
            autocomplete="off"
          ></BaseTextField>

          <PasswordRequirements :password="$lojas_usuarios.user.senha" />
        </v-row>
        <v-row class="mb-4">
          <BaseTextField
            label="Confirmar nova senha"
            required
            id="senha3"
            name="senha3"
            placeholder="******"
            v-model="$lojas_usuarios.user.senha2"
            :type="$lojas_usuarios.user.show_senha2 ? 'text' : 'password'"
            :append-icon="
              $lojas_usuarios.user.show_senha2
                ? $config.icons.viewOff
                : $config.icons.view
            "
            @click:append="
              $lojas_usuarios.user.show_senha2 =
                !$lojas_usuarios.user.show_senha2
            "
            tabindex="3"
            autocomplete="off"
          ></BaseTextField>
        </v-row>
        <v-row>
          <v-btn
            height="45"
            class="button button-bg rounded-lg"
            block
            tabindex="4"
            type="submit"
          >
            <span>Alterar senha</span>
          </v-btn>
        </v-row>
      </v-form>
    </v-card>
    <waves :lower-text="true" />
  </div>
</template>

<script>
import waves from "@/components/global/waves.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import PasswordRequirements from "../../components/forms/PasswordRequirements.vue";
export default {
  name: "RedefinePassword",
  components: {
    waves,
    BaseTextField,
    PasswordRequirements,
  },
  metaInfo: {
    title: "Redefinir Senha | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Redefinir Senha | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      redefinirSenha: {
        senhaAntiga: "",
        senhaNova: "",
        senhaNovaConfirm: "",
        showPass1: false,
        showPass2: false,
        showPass3: false,
      },
    };
  },
  mounted() {
    if (!this.$axios.getLocal("oe_user_info")) {
      this.$axios.rota("login");
    }
  },
};
</script>

<style scoped>
.pessoas-redefinir-senha-container {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.pessoas-redefinir-senha-container1 {
  width: 550px;
  height: auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  z-index: 3;
}

.pessoas-redefinir-senha-header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pessoas-redefinir-senha-form {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.625rem;
}

.back-button {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
